/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { useEffect, useRef, useState } from "react";

/**
 * Returns `true` for `durationMs` whenever the given numeric value increases
 * compared to its previous value (e.g. to animate a wallet balance going up).
 */
export const useValuePulseOnIncrease = (
  value: number | undefined,
  durationMs = 1200,
): boolean => {
  const [isPulsing, setIsPulsing] = useState(false);
  const previousValueRef = useRef(value);

  useEffect(() => {
    const previousValue = previousValueRef.current;
    previousValueRef.current = value;

    if (
      typeof value !== "number" ||
      typeof previousValue !== "number" ||
      value <= previousValue
    ) {
      return;
    }

    setIsPulsing(true);
    const timeoutId = setTimeout(() => setIsPulsing(false), durationMs);

    return () => clearTimeout(timeoutId);
  }, [value, durationMs]);

  return isPulsing;
};
